import req from '@/utils/request.config'
export default {
  list:(url,searchValue,ele)=>{
    req.post(url, searchValue).then(res => {
      if(!res.data.data){
        this.$message.closeAll();
        this.$message.warning('查询无数据！');
      }else{
        if(res.data.data.length==0){
          ele.$message.closeAll();
          ele.$message.warning('查询无数据！');
        }
        ele.tableData = res.data.data;
        ele.searchValue.total = res.data.pagination.total;
      }

    })
  },
  list1:(url,searchValue,ele)=>{
    req.post(url, searchValue).then(res => {
      if(!res.data.data){
        this.$message.closeAll();
        this.$message.warning('查询无数据！');
      }else{
        if(res.data.data.length==0){
          ele.$message.closeAll();
          ele.$message.warning('查询无数据！');
        }
        ele.tableData = res.data.data;
        ele.copyProSearchParams.total = res.data.pagination.total;
      }

    })
  },
  tableList:(url,searchValue,ele)=>{
    req.post(url, searchValue).then(res => {
      if(!res.data.data){
        this.$message.closeAll();
        this.$message.warning('查询无数据！');
      }else{
      if(res.data.data.length==0){
        ele.$message.closeAll();
        ele.$message.warning('查询无数据！');
      }
      ele.tableArray= res.data.data;
      ele.copyProSearchParams.total = res.data.pagination.total;}
    })
  },
  tableList1:(url,searchValue1,ele)=>{
    req.post(url, searchValue1).then(res => {
      if(!res.data.data){
        this.$message.closeAll();
        this.$message.warning('查询无数据！');
      }else{
      if(res.data.data.length==0){
        ele.$message.closeAll();
        ele.$message.warning('查询无数据！');
      }
      ele.tableArray1= res.data.data;
      ele.copyProSearchParams1.total = res.data.pagination.total;}
    })
  },
  tableList2:(url,searchValue2,ele)=>{
    req.post(url, searchValue2).then(res => {
      if(!res.data.data){
        this.$message.closeAll();
        this.$message.warning('查询无数据！');
      }else{
      if(res.data.data.length==0){
        ele.$message.closeAll();
        ele.$message.warning('查询无数据！');
      }
      ele.tableArray2= res.data.data;
      ele.copyProSearchParams2.total = res.data.pagination.total;  }
    })
  }
}



// WEBPACK FOOTER //
// ./src/static/getList.js